import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'ihm-snackbar',
  template: ``,
  styleUrls: ['./ihm-snackbar.component.scss']
})
export class IhmSnackbarComponent implements OnInit {
  constructor(private _snackBar: MatSnackBar) {}
  @Input() readonly message: string;
  @Input() readonly showCloseIcon: boolean = false;
  ngOnInit() {
    if (this.showCloseIcon) {
      this._snackBar.openFromComponent(IhmSnackbarContentComponent, {
        data: {
          message: this.message,
          snackbar: this._snackBar
        },
        panelClass: ['ihm-mat-snack-bar-container'],
        duration: 3000,
        verticalPosition: 'top'
      });
    } else {
      this._snackBar.open(this.message, '', { duration: 3000 });
    }
  }
}

@Component({
  selector: 'app-ihm-snackbar-content',
  templateUrl: './ihm-snackbar.component.html',
  styleUrls: ['./ihm-snackbar.component.scss']
})
export class IhmSnackbarContentComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
  closeSnackbar() {
    this.data.snackbar.dismiss();
  }
}
